import React from 'react';
import { Box, Button, Link, Modal, Stack, Typography } from '@mui/material';
import { style } from './styles';

type PropTypes = {
  handlePlayPracticeGameClick: () => void;
  handleSkipPracticeGameClick: () => void;
  openLaunchPracticeGameModal: boolean;
};

export const LaunchPracticeGameModal = ({
  handlePlayPracticeGameClick,
  handleSkipPracticeGameClick,
  openLaunchPracticeGameModal,
}: PropTypes) => {
  return (
    <Modal open={openLaunchPracticeGameModal}>
      <Box sx={style}>
        <Typography variant="h5">Start with a practice game.</Typography>
        <Typography variant="body1" mt={3}>
          ...or you can{' '}
          <Link
            href="https://www.youtube.com/watch?v=eGDBR2L5kzI&ab_channel=gordievsky"
            target={'_blank'}
          >
            skip
          </Link>{' '}
          and jump right into the main modes.
        </Typography>
        <Stack direction={'row'} mt={4}>
          <Button
            variant="text"
            onClick={handleSkipPracticeGameClick}
            fullWidth
          >
            SKIP
          </Button>
          <Button
            variant="contained"
            onClick={handlePlayPracticeGameClick}
            fullWidth
          >
            PLAY PRACTICE GAME
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
